<ng-container *ngIf="isLoading; then loading else content"></ng-container>

<ng-template #loading>
  <div class="panel-dummy newsitem">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy newsitem">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy newsitem">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy newsitem">
    <div class="shine"></div>
  </div>
</ng-template>

<ng-template #content >
  <div *ngIf="news.length">
    <ng-container *ngFor="let newsItem of news">
      <div class="newsitem clickable" (click)="onNewsItemClick(newsItem)">
        <div class="newsimg newsimg-background">
         <div class="newsimg" style="background-image: url({{newsItem.imageUrl}});"></div>
        </div>
        <div class="newscontent">
          <div class="date-title-wrapper">
            <div>{{newsItem.title}}</div>
          </div>
          <div class="icon-wrapper"><mat-icon class="chevron">chevron_right</mat-icon></div>
        </div>         
      </div>
      
    </ng-container>
  </div>
</ng-template>